// extracted by mini-css-extract-plugin
export default {"overlay-modal":"modal_overlay-modal__nRc0R","modal":"modal_modal__m9BXP","close":"modal_close__HxXHj"};